<template>
  <v-dialog persistent v-model="$store.state.auth.loginDialog" max-width="500" lazy>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary" class="row d-flex" wrap>
        <v-flex xs12 sm6>
          <v-toolbar-title
            :class="{'subheading': $vuetify.breakpoint.xsOnly}"
          >{{ !waitingSecondFactorAuth ? $t('signInCaption') : $t('twoFactorSignInCaption') }}</v-toolbar-title>
        </v-flex>
        <v-flex color="light" xs8 sm7 class="text-xs-right" v-if="$vuetify.breakpoint.smAndUp">
          <v-btn
            style="min-width : auto"
            v-for="entry in languages"
            :key="entry.title"
            color="white"
            flat
            class="pa-0 ma-0 pl-2 pr-2"
            @click="changeLocale(entry.language)"
            :outline="isCurrentLocale(entry.language)"
          >
            <span class="white--text body-2">{{entry.title}}</span>
          </v-btn>
        </v-flex>
        <v-flex color="light" xs4 sm5 v-if="$vuetify.breakpoint.xsOnly">
          <v-select
            class="ma-0 pa-0 pl-2 mr-1 mt-3 text-uppercase"
            width="20"
            :items="languages"
            item-text="title"
            item-value="language"
            v-model="selected"
          ></v-select>
        </v-flex>
      </v-toolbar>
      <v-card-text>
        <v-form v-if="!waitingSecondFactorAuth">
          <v-alert type="error" dismissible v-model="alert">{{ error }}</v-alert>
          <v-text-field
            prepend-icon="person"
            v-model="login"
            name="username"
            id="user-text-field"
            autocomplete="username"
            :label="$t('login')"
            type="email"
            @keyup.enter="userSignIn({login, password, remember})"
          ></v-text-field>
          <v-text-field
            prepend-icon="lock"
            v-model="password"
            name="password"
            value="password"
            autocomplete="current-password"
            :label="$t('password')"
            id="password-text-field"
            type="password"
            @keyup.enter="userSignIn({login, password, remember})"
          ></v-text-field>
          <v-card-actions>
            <v-checkbox v-model="remember" :label="$t('remember')"></v-checkbox>
            <v-btn icon :href="instructionUrl" target="_blank">
              <v-icon>live_help</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
        <v-form v-else>
          <v-alert type="error" dismissible v-model="alert">{{ error }}</v-alert>
          <v-text-field
            prepend-icon="security"
            v-model="secondFactor"
            name="secondFactor"
            :label="$t('secondFactor')"
            :placeholder="$t('secondFactor')"
            type="text"
            @keyup.enter="secondFactorLogin(secondFactor)"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <a
          href="https://smartid.smarttender.biz/login/Account/ForgotPassword"
          target="_blank"
        >{{ $t('recoverPassword') }}</a>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="$store.state.auth.loginDialog = false"
        >{{ $t('cancelFull') }}</v-btn>
        <v-btn
          color="primary"
          type="submit"
          value="Login"
          name="submit"
          :disabled="loading"
          :loading="loading"
          @click="signInPressed"
        >{{ $t('signIn') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-alert class="pa-2 ma-0" :value="!cookie" type="error">{{ $t('cookies') }}</v-alert>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { i18n } from '../i18n'

export default {
  name: 'AllEquipment',
  data() {
    return {
      login: '',
      password: '',
      remember: false,
      secondFactor: '',
      alert: false,
      selected: null,
      languages: [
        { flag: 'us', language: 'en', title: 'ENG' },
        { flag: 'ua', language: 'uk', title: 'УКР' }
      ]
    }
  },
  mounted() {
    this.selected = i18n.locale
  },
  methods: {
    ...mapActions(['userSignIn', 'secondFactorLogin']),
    changeLocale(locale) {
      i18n.locale = locale
      localStorage.setItem('userLocale', locale)
      setTimeout(() => {
        this.$store.commit(
          'setNavigationDrawer',
          this.$vuetify.breakpoint.mdAndUp
        )
      }, 500)
    },
    isCurrentLocale(locale) {
      return i18n.locale == locale
    },
    signInPressed() {
      if (!this.waitingSecondFactorAuth) {
        this.userSignIn({
          login: this.login,
          password: this.password,
          remember: this.remember
        })
      } else {
        this.secondFactorLogin(this.secondFactor)
      }
    }
  },
  computed: {
    cookie() {
      return navigator.cookieEnabled
    },
    error() {
      return this.$store.state.base.error
    },
    loading() {
      return this.$store.state.base.loading
    },
    instructionUrl() {
      return require('../assets/instruction.pdf')
    },
    waitingSecondFactorAuth() {
      return this.$store.state.auth.waitingSecondFactorAuth
    }
  },
  watch: {
    selected() {
      i18n.locale = this.selected
    },
    error(value) {
      if (value) {
        this.alert = true
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  }
}
</script>

